export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  coverImage: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'a1',
    slug: '2026-nian-zuishou-huanying-dianying',
    title: '2026年最受欢迎十大电影盘点：国产片强势崛起',
    excerpt: '回顾2026年上半年，国产电影市场表现亮眼，多部作品在票房和口碑上取得双丰收。本文将为您盘点今年最受欢迎的十部电影。',
    content: `<p>2026年已经过半，回顾这半年的电影市场，国产电影表现格外抢眼。从春节档的科幻巨制到暑期档的动画佳作，中国电影工业的实力正在不断提升。</p>
    <h2>科幻电影引领潮流</h2>
    <p>《流浪地球3》延续了前两部的高水准制作，在视觉效果和故事深度上都达到了新的高度。影片通过宏大的宇宙场景和细腻的人物刻画，展现了中国科幻电影的独特魅力。</p>
    <p>另一部备受瞩目的科幻作品《三体：黑暗森林》也即将在下半年上映，影迷们已经迫不及待。</p>
    <h2>动画电影异军突起</h2>
    <p>《长安三万里》以其独特的唐风美学和深刻的文学内涵，成为今年最具文化底蕴的动画电影。影片通过高适和李白的故事，让观众重新认识了大唐诗人的精神世界。</p>
    <h2>综艺电影新尝试</h2>
    <p>多档热门综艺节目纷纷推出大电影版本，将小屏幕的欢乐延续到大银幕，满足了不同观众的观影需求。</p>
    <p>总的来说，2026年的中国电影市场呈现出多元化、高质量的发展趋势，观众的审美水平也在不断提高，这促使电影制作方更加注重作品的内容和品质。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20Chinese%20film%20posters%2C%20golden%20trophy%20and%20spotlights%2C%20elegant%20red%20carpet%20setting%2C%20warm%20atmospheric%20lighting%2C%20editorial%20quality&width=1200&height=600&seq=article-cover-01&orientation=landscape',
    category: 'dianying',
    author: '影评人小王',
    date: '2026-08-10',
    readTime: '8分钟',
    tags: ['电影', '盘点', '国产电影'],
  },
  {
    id: 'a2',
    slug: 'guoman-jueqi-zhilu',
    title: '国漫崛起之路：从模仿到创新的华丽转身',
    excerpt: '近年来，国产动漫作品质量不断提升，从画风到剧情都展现出独特的中国美学风格，国漫正在用自己的方式讲述中国故事。',
    content: `<p>近十年来，国产动漫经历了从量变到质变的飞跃。从早期的模仿日美风格，到现在形成独特的中国风美学体系，国漫正在用自己的方式讲述中国故事。</p>
    <h2>技术突破带来视觉革新</h2>
    <p>随着3D渲染技术和2D手绘技术的不断进步，国产动漫的画面质量已经达到了国际一流水平。《狐妖小红娘》《斗罗大陆》等作品在角色设计和场景美术上的表现令人惊艳。</p>
    <h2>文化自信催生独特风格</h2>
    <p>从《大圣归来》到《长安三万里》，国漫越来越多地从中国传统文化中汲取灵感。水墨风格、工笔技法、古典建筑等元素被巧妙地融入到动画创作中。</p>
    <h2>原创IP持续发力</h2>
    <p>《诛仙》《第一序列》等原创IP动画化的成功，证明了国产动漫在原创内容方面的巨大潜力。越来越多的网文IP被改编为高质量的动画作品。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20Chinese%20animation%20art%20showcase%20with%20various%20anime%20characters%20in%20traditional%20Chinese%20painting%20style%2C%20ink%20wash%20background%2C%20golden%20accents%2C%20artistic%20exhibition%20display&width=1200&height=600&seq=article-cover-02&orientation=landscape',
    category: 'dongman',
    author: '动漫观察员',
    date: '2026-08-05',
    readTime: '6分钟',
    tags: ['国漫', '动画', '文化'],
  },
  {
    id: 'a3',
    slug: 'jilupian-tuijian-2026',
    title: '2026年必看纪录片推荐：打开认知世界的新视角',
    excerpt: '纪录片是了解世界的最佳窗口。本文精选2026年最值得观看的十部纪录片，涵盖自然、历史、科技等多个领域。',
    content: `<p>纪录片以其真实的力量和独特的视角，一直是视频内容市场的重要组成部分。2026年涌现了大量优秀的纪录片作品。</p>
    <h2>自然类纪录片</h2>
    <p>《地球脉动·祖国篇》用4K超高清镜头，完整记录了中国从北到南、从东到西最壮美的自然景观。从青藏高原的雪山到南海的珊瑚礁，每一帧都是绝美的壁纸。</p>
    <h2>科技探索类</h2>
    <p>《宇宙创造之旅》带领观众走进最前沿的天文学研究，用通俗易懂的方式解释复杂的宇宙现象，非常适合科学爱好者。</p>
    <h2>人文历史类</h2>
    <p>多部关于中国传统文化的纪录片也值得关注，它们深入挖掘了非遗技艺、古城保护和民俗传承等主题。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20wildlife%20and%20landscapes%2C%20professional%20camera%20equipment%20silhouette%2C%20golden%20hour%20lighting%2C%20National%20Geographic%20style%20photography&width=1200&height=600&seq=article-cover-03&orientation=landscape',
    category: 'jilupian',
    author: '纪录片迷',
    date: '2026-07-28',
    readTime: '7分钟',
    tags: ['纪录片', '推荐', '自然'],
  },
  {
    id: 'a4',
    slug: 'duanshipin-chuangzuo-jiqiao',
    title: '短视频创作技巧：从零开始打造爆款内容',
    excerpt: '想要在短视频平台上脱颖而出？本文分享专业创作者的实战经验，包括选题策划、拍摄技巧、剪辑节奏等核心要点。',
    content: `<p>短视频已经成为当下最流行的内容形式。无论你是想记录生活，还是希望成为专业创作者，掌握一些基本技巧都能让你的作品更上一层楼。</p>
    <h2>选题是成功的一半</h2>
    <p>好的选题能让你的视频自带流量。关注热点话题、挖掘生活细节、展现专业知识，都是不错的选题方向。</p>
    <h2>拍摄技巧决定观感</h2>
    <p>稳定的画面、合理的光线、清晰的收音是高质量短视频的基础。即使使用手机拍摄，也能通过一些简单的技巧大幅提升画面质量。</p>
    <h2>剪辑节奏把握关键</h2>
    <p>短视频的黄金时长是15-60秒，前3秒必须抓住观众注意力。合理的节奏控制和音乐搭配能让视频更出彩。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20content%20creator%20workspace%20with%20smartphone%20on%20tripod%2C%20ring%20light%2C%20colorful%20background%2C%20creative%20vlogging%20setup%2C%20warm%20and%20inviting%20atmosphere&width=1200&height=600&seq=article-cover-04&orientation=landscape',
    category: 'duanshipin',
    author: '创作达人',
    date: '2026-07-20',
    readTime: '10分钟',
    tags: ['短视频', '创作', '教程'],
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}